import styled from 'styled-components';
import { animated } from 'react-spring';

export const Wrapper = styled(animated.div)`
    height: 300px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;
